import { useState } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import userInfoAtom, { loadableUserInfoAtom } from '~atoms/userInfoAtom';

import PrivacyPolicyDialog from '../components/privacyPolicyDialog';

/**
 * Raises the blocking privacy policy dialog for a user who has not accepted
 * the current policy yet.
 *
 * Only an explicit `false` opens it. An absent flag means the backend did not
 * say, and blocking the panel on an unknown answer would be worse than showing
 * the dialog one session late.
 */
const PrivacyPolicyGate = () => {
	const loadableUserInfo = useAtomValue(loadableUserInfoAtom);
	const refreshUserInfo = useSetAtom(userInfoAtom);

	// The acceptance is recorded server side before this flips, so it only
	// covers the gap until the refreshed user arrives.
	const [isAccepted, setIsAccepted] = useState(false);

	const user = loadableUserInfo.state === 'hasData' ? loadableUserInfo.data : null;

	if (isAccepted || user?.hasAcceptedPrivacyPolicy !== false) {
		return null;
	}

	return (
		<PrivacyPolicyDialog
			onAccepted={() => {
				setIsAccepted(true);
				refreshUserInfo();
			}}
		/>
	);
};

export default PrivacyPolicyGate;
